import RandingStyle19 from "../../randing/RandingStyle19";

function Randing148({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle19
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      totalStep="3"
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/148/1.gif`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/143/2-1.jpg`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/146/3-1.jpg`}
      changedIMG={`${process.env.REACT_APP_CDN_BASE}/images/017/01_241101_03.jpg`} // 스텝 변경되는 이미지
      numberColor="#201c54"
      qOptionColor="blue"
      qOptionColor2="age"
      qTitleColor="#204cec"
      formFieldColor="white"
      audioOn={true}
      passBTN={`${process.env.REACT_APP_CDN_BASE}/images/143/1-2.png`}
      keepBTN={`${process.env.REACT_APP_CDN_BASE}/images/143/2-2.png`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyButton2.png`}
      companyName="본원"
      privacyCompanyName="청춘플란트치과의원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/woori2.jpg`}
      randingNumber="148"
    />
  );
}

export default Randing148;
